// extracted by mini-css-extract-plugin
export default {"eventRow":"Event-module__eventRow___jHcFT","eventName":"Event-module__eventName___rgsI2"};